import { render, staticRenderFns } from "./AddNewChild.vue?vue&type=template&id=2d965d75&scoped=true&"
import script from "./AddNewChild.vue?vue&type=script&lang=js&"
export * from "./AddNewChild.vue?vue&type=script&lang=js&"
import style0 from "./AddNewChild.vue?vue&type=style&index=0&id=2d965d75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d965d75",
  null
  
)

export default component.exports